import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8, -2)">
      <g transform="translate(11, 5)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <g transform="translate(8, 16) scale(0.125)">
          <path
            fill="currentColor"
            d="M340.87,186.92l-14.53-4.13h15.07c1.75,1.17,2.25,2.16,1.51,3A2.78,2.78,0,0,1,340.87,186.92Z"
            transform="translate(-55.04 -182.79)"
          />
          <path
            fill="currentColor"
            d="M340.87,186.92a15.16,15.16,0,0,0,.54-4.13h15.08Z"
            transform="translate(-55.04 -182.79)"
          />
          <path
            fill="currentColor"
            d="M385.27,498.22c-8.34,3.63-14.11,8.42-17.28,7.08-8.82-3.74-16.56-10-24.73-15.3,6.15-5.57,15.6-17,17.85-15.68C369.57,479.13,375.68,488.07,385.27,498.22Z"
            transform="translate(-55.04 -182.79)"
          />
          <path
            fill="currentColor"
            d="M166.13,498.19c8.56,8,15.37,12.4,18.84,18.65,1.16,2.1-8.3,13.36-9.38,12.86A73.82,73.82,0,0,1,155,515.25C154.22,514.46,160.81,506.23,166.13,498.19Z"
            transform="translate(-55.04 -182.79)"
          />
          <path
            fill="currentColor"
            d="M221.14,533.59,205.44,517c4.57-3.77,11.09-11.63,13.33-10.56,7.12,3.42,12.65,10.16,18.8,15.62Z"
            transform="translate(-55.04 -182.79)"
          />
          <path
            fill="currentColor"
            d="M530.87,416.41c-40,50.24-80.48,100.14-119.84,150.9-8.59,11.08-15.13,12.47-26.18,4.75-44.38-31-89.33-61.21-133.45-92.6-9.76-6.94-17-17.49-25.33-26.37,10.48-3.93,20.84-8.22,31.47-11.69,15-4.88,28.06-9.33,40.36,9.11,9.74,14.62,35.13,9.73,40.94-7.73,5.23-15.74,11.58-13.54,23.59-10.56,14.17,3.52,30.79,8.63,43.44,4.39,26.59-8.92,46.1-71.12,33.58-97.06-8.2-17-25.66-19.87-34.47-3.79-10.25,18.7-17.31,39.28-24.46,59.5-4.67,13.2,1.76,19,15.43,16.69,6.44-21.2,12.87-42.4,20.21-66.6,12.8,24.57,4.74,50.38-19.54,73.19-18.27,3.39-34-1.4-47.73-14-12.95-11.84-20.61-8.38-22.57,8.89-.38,3.29-.71,7-2.43,9.61-3,4.57-7.09,8.45-10.72,12.62-3-3.48-7.2-6.5-8.68-10.52-4.72-12.85-13.28-12.63-24.13-9.22a337.87,337.87,0,0,1-36.29,9.51c-11.51,2.25-23.32,3-35,4.42,6.9-10,13.26-20.47,20.79-30,48.1-60.8,96.55-121.31,144.66-182.1,9.58-12.12,16.74-24.92-3-35H306.25c-13.55,3-27.26,5.37-40.56,9.19-4.58,1.32-8.15,6.15-12.18,9.38,4.23,2,8.49,5.92,12.69,5.85,22.58-.34,45.13-2,67.71-2.38,5.08-.08,10.21,3.24,15.31,5-2,4.38-3.17,9.37-6.05,13.05q-82.46,105.74-165.47,211C174,438.57,167.61,443.35,162,444c-35.58,4-71.29,6.87-107,10.11v10c38.42-.27,77,1.53,115.19-1.68,18.7-1.57,31.19,3.09,45,14.16,44.21,35.56,87.12,73.48,134.75,103.86,56.26,35.88,49.09,35.41,91.68-19.12,36.86-47.18,77.1-91.71,115.84-137.42V408.88C545.57,400.74,538,407.5,530.87,416.41Z"
            transform="translate(-55.04 -182.79)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default IconLogo;
